import { useT } from "@/i18n/LanguageContext";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export default function LanguageSelector({ inverted = false }) {
  const { lang, setLang, languages } = useT();
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-selector"
        aria-label="Language"
        className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium transition-colors ${
          inverted ? "text-white/95 hover:bg-white/15" : "text-slate-700 hover:bg-cream-100"
        }`}
      >
        <Globe size={15} strokeWidth={2} />
        <span className="hidden sm:inline uppercase text-xs tracking-wider font-semibold">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 border-cream-200">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer py-2.5"
          >
            <span className="flex items-center gap-2.5">
              <span className="text-base leading-none">{l.flag}</span>
              <span className="text-sm font-medium">{l.label}</span>
            </span>
            {lang === l.code && <Check size={14} className="text-navy-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
